(() => {
  const stripsCarouselEls = document.querySelectorAll('[data-strips-carousel]');

  const init = () => {
    if (!window.stripsCarouselInit) {
      window.stripsCarouselInit = true;

      Array.from(stripsCarouselEls).forEach((stripsCarouselEl) => {
        const popupToggleEls = stripsCarouselEl.querySelectorAll('[data-strips-carousel-popup-toggle]');
        const sliderEls = stripsCarouselEl.querySelectorAll('[data-strips-carousel-slider]');
        const categoriesSliderEl = stripsCarouselEl.querySelector('[data-strips-carousel-categories-slider]');
        const popupEl = stripsCarouselEl.querySelector('[data-strips-carousel-popup]');

        Array.from(popupToggleEls).forEach((popupToggleEl) => {
          popupToggleEl.addEventListener('click', handlePopupToggle);
        });

        Array.from(sliderEls).forEach((sliderEl) => {
          initSlider(sliderEl);
        });

        if (categoriesSliderEl) {
          initCategoriesSlider(categoriesSliderEl);
        }

        popupEl.addEventListener('click', handlePopupClick);
      });
    }
  }

  const handlePopupToggle = (event) => {
    const popupToggleEl = event.target;

    popupToggleEl.closest('[data-strips-carousel]').classList.toggle('popup-open');
  }

  const handlePopupClick = (event) => {
    const popupEl = event.target;

    if (popupEl.classList.contains('strips-carousel__popup')) {
      popupEl.closest('[data-strips-carousel]').classList.remove('popup-open');
    }
  }

  const initCategoriesSlider = (sliderEl) => {
    const slider = tns({
      container: sliderEl,
      items: 1,
      edgePadding: 80,
      center: true,
      nav: false,
      mouseDrag: true,
      swipeAngle: false,
      loop: false,
      responsive: {
        1: {
          disable: false,
        },
        741: {
          items: 2,
          edgePadding: 300
        }
      },
      onInit: (info) => {
        const indexCurrent = info.index;

        info.slideItems[indexCurrent].classList.add('active');
      }
    });

    const sliderElements = document.getElementsByClassName('strips-carousel__categories-slide');
    Array.from(sliderElements).forEach(element => element.onclick = function(event) {
      let sliderInfo = slider.getInfo();
      let slideClickedIndex = Array.from(sliderInfo.slideItems).findIndex(el => el === event.target);

      if(slideClickedIndex > sliderInfo.index){
        slider.goTo('next');
      } else if (slideClickedIndex < sliderInfo.index) {
        slider.goTo('prev');
      }
    });

    slider.events.on('indexChanged', handleCategoriesSliderIndexChanged);
  }

  const initSlider = (sliderEl) => {
    const slider = tns({
      container: sliderEl,
      items: 1,
      edgePadding: 80,
      nav: false,
      mouseDrag: true,
      swipeAngle: false,
      loop: true,
      responsive: {
        1: {
          disable: false
        },
        565: {
          edgePadding: 150,
        },
        741: {
          edgePadding: 200
        },
        1000: {
          edgePadding: 300
        },
        1200: {
          edgePadding: 400
        },
        1300: {
          edgePadding: 420
        }
      },
      onInit: (info) => {
        const indexCurrent = info.index;

        info.slideItems[indexCurrent].classList.add('active');
      }
    });

    slider.events.on('indexChanged', handleSliderIndexChanged);
  }

  const handleSliderIndexChanged = (info) => {
    const indexCurrent = info.index;

    Array.from(info.slideItems).forEach((slideItem) => {
      slideItem.classList.remove('active');
    });
    info.slideItems[indexCurrent].classList.add('active');
  }

  const handleCategoriesSliderIndexChanged = (info) => {
    const indexCurrent = info.index;
    const stripsCarouselEl = info.container.closest('[data-strips-carousel]');
    const categoryHandle = info.slideItems[indexCurrent].dataset.stripsCarouselCategoriesSlide;

    Array.from(info.slideItems).forEach((slideItem) => {
      slideItem.classList.remove('active');
    });
    info.slideItems[indexCurrent].classList.add('active');

    Array.from(stripsCarouselEl.querySelectorAll(`[data-strips-carousel-category]`)).forEach((stripsCarouselCategoryEl) => {
      stripsCarouselCategoryEl.classList.remove('active');
    });

    stripsCarouselEl.querySelector(`[data-strips-carousel-category="${categoryHandle}"]`).classList.add('active');
  }

  document.addEventListener("DOMContentLoaded", init);
})();